import Project from "./Types/Project";
import Journal from "./Types/Journal";
import Issue from "./Types/Issue";

export default {
  Project,
  Journal,
  Issue
};
